import { NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';
import { EntryComponent } from '@app/entry/entry.component';
import { AccountGuard } from './core/guards';
import { MyAccountResolver, UserStateResolver } from '@core/resolvers';
import { ComponentConfigResolver } from './component-config.resolver';
import { RedirectGuard } from './core/guards/redirect.guard';
import { CheckoutGuard } from './core/guards/checkout.guard';

const standardRoutes: Routes = [
	{
		path: '**',
		component: EntryComponent,
		canActivate: [RedirectGuard,AccountGuard, CheckoutGuard],
		resolve: {
			state: UserStateResolver,
			user: MyAccountResolver,
			componentMapping: ComponentConfigResolver,
		},
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot([...standardRoutes], {
			initialNavigation: 'enabledBlocking',
			scrollOffset: [0, 160],
			onSameUrlNavigation: 'reload',
			scrollPositionRestoration: 'top',
			urlUpdateStrategy: 'eager',
			preloadingStrategy: NoPreloading
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
